import React, { useState } from "react";
import { Grid, CircularProgress } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import { useHistory } from "react-router-dom";
import { useQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import moment from "moment";

import { Card, CardContent, CardActions } from "../../components/Card";
import Table from "../../components/Table";
import { useAlert } from "../../components/Alert";

const GET_PERSONALMESSAGES = gql`
  query personalMessages(
    $id: Int
    $type: PersonalMessageType
    $searchTerm: String
    $latest: Boolean
    $status: AssignmentStatus
    $pageSize: Int
    $page: Int
  ) {
    personalMessages(
      id: $id
      type: $type
      searchTerm: $searchTerm
      latest: $latest
      status: $status
      pageSize: $pageSize
      page: $page
    ) {
      count
      pageCount
      contents {
        id
        category {
          id
          name
          createdAt
          updatedAt
        }
        task
        response
        status
        statusUpdatedAt
        expectedFinishedAt
        shouldFinishAt
        finishedAt
        assignTo {
          id
          fullName
        }
        assignedBy {
          id
          fullName
        }
        updatedBy {
          id
          fullName
        }
        nameOfReservation
        customer {
          id
        }
        user {
          id
        }
        reservation
        content
        foreclosureUpdateLog
        type
        readed
        createdAt
        updatedAt
      }
    }
  }
`;

const CHANGE_PERSONALMESSAGEREADED = gql`
  mutation changePersonalMessageReaded($id: Int!) {
    changePersonalMessageReaded(id: $id)
  }
`;

export default function PersonalMessageTable() {
  const [page, setPage] = useState(1);
  const history = useHistory();
  const Alert = useAlert();
  const { data, loading } = useQuery(GET_PERSONALMESSAGES, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      id: Number(localStorage.getItem("@fullhouseUserId")),
      latest: true,
      pageSize: 10,
      page,
    },
    onError(error) {
      return Alert.notice(error.message.replace("GraphQL error: ", ""));
    },
  });

  const [
    changePersonalMessageReaded,
    { loading: changePersonalMessageReadedLoading },
  ] = useMutation(CHANGE_PERSONALMESSAGEREADED);

  if (loading) {
    return (
      <Grid container item justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Card>
        <CardContent>
          <Table
            data={data?.personalMessages.contents ?? []}
            tableWidth={2}
            header={["編號", "訊息", "時間", "狀態"]}
            columns={[
              (_, index) => index + 1,
              (item) => {
                switch (item.type) {
                  case "ASSIGNMENT":
                    return `狀態更新時間：${moment(item.updatedAt).format(
                      "yyyy/MM/DD"
                    )}，工作內容：${item.task}，最後更新者：${
                      item.updatedBy.fullName
                    }，狀態：${(() => {
                      switch (item.status) {
                        case "PENDING":
                          return "未進行";
                        case "TO_BE_DECIDED":
                          return "待決策";
                        case "IN_PROGRESS":
                          return "進行中";
                        case "FINISHED":
                          return "已完成";
                        default:
                          break;
                      }
                    })()}，狀態說明：${item.response ?? ""}`;
                  case "RESERVATION":
                    return `客戶：${item.nameOfReservation}，預約日期：${moment(
                      item.reservation
                    ).format("yyyy/MM/DD")}，追蹤內容：${item.content}`;
                  case "FORECLOSUREUPDATE":
                    return item.foreclosureUpdateLog;
                  default:
                    break;
                }
              },
              (item) => moment(item.createdAt).format("yyyy-MM-DD"),
              (item) => (item.readed ? "已讀" : "未讀"),
            ]}
            onPress={(item) => {
              changePersonalMessageReaded({ variables: { id: item.id } });
              switch (item.type) {
                case "ASSIGNMENT":
                  return history.replace("/console/assignments");
                case "RESERVATION":
                  if (item.customer)
                    localStorage.setItem(
                      "@fullhouseCustomer",
                      item.customer.id
                    );
                  else localStorage.setItem("@fullhouseCustomer", item.user.id);
                  return history.replace("/console/customer-center");
                case "FORECLOSUREUPDATE":
                  return history.replace("/console/new-favorite");
                default:
                  break;
              }
            }}
          />
        </CardContent>
        <CardActions>
          <Grid container justifyContent="center">
            <Pagination
              count={
                Boolean(data) && data.personalMessages.pageCount
                  ? data.personalMessages.pageCount
                  : 1
              }
              size="large"
              color="primary"
              page={page}
              onChange={(e, n) => {
                setPage(n);
              }}
            />
          </Grid>
        </CardActions>
      </Card>
    );
  }
}
